import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useNetworkSearch = (page = 1, term) => useQuery({ queryKey: [`network-search`, page, term], queryFn: async () => {
    if(!term) return []
    const callback = await API.get(`/network/search?term=${term}`)
    return callback?.data
}, staleTime: 1000 * 60 * 60 * 12, gcTime: 1000 * 60 * 60 * 24 * 7 })

export default useNetworkSearch